import { Delete } from '@mui/icons-material';
import { FC } from 'react';
import { StyledDiscardButton } from 'src/components/styled/DiscardButton';

interface Props {
    tooltip?: string;
    loading?: boolean;
    disabled?: boolean;
    onClick?: () => unknown;
}

const DiscardButton: FC<Props> = ({ tooltip, loading, disabled, onClick }) => {
    return (
        <>
            <StyledDiscardButton
                className="discard-button"
                disabled={disabled ?? loading}
                disabledTooltip={tooltip}
                color={'error'}
                size="medium"
                variant={'contained'}
                startIcon={<Delete />}
                onClick={onClick}
                sx={{ textTransform: 'uppercase!important' }}
            >
                Discard
            </StyledDiscardButton>
        </>
    );
};

export default DiscardButton;
